<template>
    <div class="exam-result-management">
        <!-- 검색/필터 영역 -->
        <div class="search-controls">
            <div class="search-row">
                <select v-model="filter.searchType" class="search-type">
                    <option value="patientNumber">환자번호</option>
                    <option value="patientName">환자명</option>
                    <option value="diseaseName">질환명</option>
                </select>
                <input v-model="filter.searchText" placeholder="검색어 입력" class="search-input" @keyup.enter="fetchExamResults(1)" maxlength="100" />
            </div>
            <div class="search-row">
                <input type="date" v-model="filter.startDate" class="date-input" />
                <span>~</span>
                <input type="date" v-model="filter.endDate" class="date-input" />
            </div>
            <div class="search-button-row">
                <button @click="search" class="search-btn">검색</button>
            </div>
        </div>

        <!-- 목록 정렬 드롭다운 -->
        <div class="list-sort">
            <select v-model="sortOption" @change="onSortOptionChange">
                <option value="recently">최근 진단일</option>
                <option value="patientNumber">환자번호</option>
                <option value="patientName">환자명</option>
                <option value="birthDate">생년월일</option>
            </select>
        </div>

        <!-- 결과 목록 테이블 -->
        <table class="result-table">
            <colgroup>
                <col style="width: 10%;">
                <col style="width: 15%;">
                <col style="width: auto;">
                <col style="width: 20%;">
                <col style="width: 20%;">
                <col style="width: 15%;">
            </colgroup>
            <thead>
                <tr>
                    <th>no</th>
                    <th>환자번호</th>
                    <th>환자명</th>
                    <th>생년월일</th>
                    <th>진단일</th>
                    <th>진단 내역</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(row) in protocolList" :key="row.connection_id">
                    <td>{{ row.resultId }}</td>
                    <td>{{ row.patientId }}</td>
                    <td>{{ row.name }}</td>
                    <td>{{ row.dob }}</td>
                    <td>{{ dateUtils.formatDate(row.examDate) }}</td>
                    <td><button @click="viewDetail(row)" class="detail-btn">이력 보기</button></td>
                </tr>
            </tbody>
        </table>

        <pagination
            :total-items="totalCount"
            :page-size="pageSize"
            v-model="currentPage"
            @page-change="onPageChange"
        />
    </div>
</template>

<script setup>
import api, { urls } from "@/api";
import { dateUtils } from "@/utils/dateUtils";
import Pagination from "@/components/common/Pagination.vue";

const filter = reactive({
    searchType: "patientName", // patientName or patientNo
    searchText: "",
    startDate: "",
    endDate: "",
})
const sortOption = ref("recently")
const protocolList = ref([])
const currentPage = ref(1)
const pageSize = ref(10)
const totalPages = ref(1)
const totalCount = ref(0)

const onPageChange = (page) => {
    fetchExamResults(page);   // 현재 페이지 갱신
}
const onSortOptionChange = () => {
    fetchExamResults(1);   // 현재 페이지 갱신
}
const fetchExamResults = async (page = 1) => {
    try {
        const params = {
            ...(filter.startDate && {startDate: filter.startDate + ' 00:00:00'}),
            ...(filter.endDate && {endDate: filter.endDate + ' 23:59:59'}),
            orderType: sortOption.value,
            page: currentPage.value,
            pageRow: pageSize.value
        };

        if(filter.searchType == 'patientNumber'){
            params.patientId = filter.searchText
        }
        if(filter.searchType == 'patientName'){
            params.name = filter.searchText
        }
        if(filter.searchType == 'diseaseName'){
            params.diseaseName = filter.searchText
        }

        const res = await api.get(urls.diagnosis.result, { params: params });

        // 서버에서 받은 데이터 구조에 따라 조정 가능
        protocolList.value = res.data.list || res.data || [];
        totalCount.value = res.data.totCnt || 0
        totalPages.value = Math.ceil(totalCount.value / pageSize.value);
        currentPage.value = page;
    } catch (err) {
        console.error("진단 결과 불러오기 실패", err);
        protocolList.value = [];
        totalCount.value = 0;
        totalPages.value = 1;
        currentPage.value = 1;
    }
}
const search = () => {
    // 검색 버튼 클릭 혹은 정렬 변경 시 호출
    fetchExamResults();
}
const viewDetail = (row) => {
    alert(
        `환자번호: ${row.patientNo}\n환자명: ${row.patientName}\n생년월일: ${row.birthDate}\n진단일: ${row.diagnosisDate}\n진단 내역: ${row.diseaseName || "없음"}`
    );
    // 상세 모달이나 페이지 이동 등 실제로 구현 필요
}

onMounted(() => {
    fetchExamResults();
})
</script>